import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { tap } from "rxjs/operators";
import { LoaderService } from "../../common/services/loader.service";
import { ChiefsOrderService } from "../../services/chiefsOrder.service";

@Injectable()
export class ChiefsOrderSignersList {

    constructor(public loaderService: LoaderService,
        public service: ChiefsOrderService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.loaderService.toggleLoader(true);
                            
        var signersList = this.service.getCurrReqSignersList().pipe(tap((data) => { this.loaderService.toggleLoader(false); }));
        return signersList;
         
    }

}